import * as React from 'react';
import { Field, reduxForm, change } from 'redux-form';
//import invoiceItemForm from '../forms/invoiceItemForm';
//import styles from './deFormStyles';
import { TouchableOpacity, StyleSheet, Platform } from 'react-native';
import { Container, Header, InputGroup, Content, Text, Label, Item, Input, Icon, Toast, Form, Spinner, View, Left, Right, Body, Button, Title, Footer } from 'native-base';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import Modal from '../components/modal';
import Picker from '../components/picker';
import * as _ from 'lodash';

import FormFooter from '../components/formFooter';
import { textInput, moneyInput, renderPicker, renderDateField, percentInput, numberInput, renderTypeAhead } from './renderedComponents';
import KeyHandler from '../components/keyHandler';

const styles = StyleSheet.create({
	modalStyle: {
		borderRadius: 10,
		width: '90%',
		maxHeight: 450
	},
	modalContainer: {
		flex: 1,
		//justifyContent: 'center',
		backgroundColor: '#f8f8fc'
	},
	innerContainer: {
		flex: 1
		//alignItems: 'center',
	},
	modalHeader: {
		height: 45,
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10
	}
});

function syncValidate(values, props) {
	//runs while field changing
	const errors = {};

	if (!values.description) errors.description = 'Required';
	if (parseFloat(values.paid) > 0 && values.account_id == 0) errors.account_id = 'Please select an account';

	return errors;
}

function asyncValidate(values, dispatch, props, field) {
	return new Promise((resolve, reject) => {
		__DEV__ && console.log('blur', field);
		//runs on BLUR for net, vat, payable, paid. So first update values
		if (field == 'ref') {
			//find matching ref and fill in other values
		} else if (field != 'qty') {
			//a £
			var value = Number(values[field]);
			var Dispval = parseFloat(isNaN(value) ? 0 : value).toFixed(2);
			__DEV__ && console.log('changing ', field, Dispval);
			dispatch(change('invoiceItemForm', field, Dispval));
		}

		if (field == 'qty' || field == 'unit') {
			//change total

			var value = Number(values['qty']) * Number(values['unit']);
			//console.log('total = ', value, values['qty'], values['unit']);
			dispatch(change('invoiceItemForm', 'total', parseFloat(isNaN(value) ? 0 : value).toFixed(2)));
		}

		if (field == 'qty') {
			__DEV__ && console.log(values.qty);
			var qtyDisp = parseFloat(isNaN(values.qty) ? 0 : values.qty).toString();
			dispatch(change('invoiceItemForm', 'qty', qtyDisp));
		}

		resolve();
	});
}

class invoiceItemForm extends React.Component {
	constructor(props) {
		super(props);

		this.initialState = { open: true, closing: false, servicesOnly: props.servicesOnly, showDiscount: !!parseFloat(this.props.initialValues.discount) };
		this.state = this.initialState;
		//console.log('invoiceItemForm - ', this.props);
	}

	_changeFormVal(field, val) {
		__DEV__ && console.log('setting ', field, val);
		this.props.dispatch(change('invoiceItemForm', field, val));
	}

	_closing() {
		console.log('tick');

		this.props.handleSubmit();
		//this.refs.form.submit();
	}

	selectedRef(item) {
		console.log('selecting item', item);
		this.props.dispatch(change('invoiceItemForm', 'description', item.description));
		this.props.dispatch(change('invoiceItemForm', 'unit', item.unit));
		this.props.dispatch(change('invoiceItemForm', 'unitname', item.unitname));
		this.props.dispatch(change('invoiceItemForm', 'vatrate', Number(item.vatrate).toString()));
		if (item.unitname) {
			this.props.changeServicesOnly(false);
			this.setState({ servicesOnly: false });
			this.props.dispatch(change('invoiceItemForm', 'qty', '1'));
		}
	}

	render() {
		const { handleSubmit, pristine, reset, submitting, changeServicesOnly, vatRates, itemRefs } = this.props;
		const { closing, servicesOnly, showDiscount } = this.state;
		this.formRefs = [];
		const inv = this.props.type == 'Invoice';
		const item = this.props.initialValues;

		const labour = item.ref && item.ref == 'Labour';
		const net = this.props.vatReg ? 'Net ' : '';
		//if (__DEV__) console.log('invoice item ...', invoice, labour);
		/*

		ref desc [qty unit] net [amount] [[discount]] vat



		*/

		return (
			<Modal isOpen backButtonClose coverScreen swipeThreshold={100} style={styles.modalStyle} onClosed={() => this.props.cancel()} onClosingState={closing => this.setState({ closing })}>
				<Header style={[styles.modalHeader, closing && (pristine ? { backgroundColor: '#e8c9c9' } : { backgroundColor: '#b94343' })]}>
					<Left>
						<Button transparent onPress={() => this.props.cancel()}>
							<Icon name="close" />
						</Button>
					</Left>
					<Body>
						<Title>{labour ? 'Labour' : 'Item'}</Title>
					</Body>
					<Right>
						<Button transparent onPress={() => this.props.handleSubmit()}>
							<Icon name="checkmark" />
						</Button>
					</Right>
				</Header>
				<KeyHandler esc={() => this.props.cancel()} />
				<View style={styles.modalContainer}>
					<View style={styles.innerContainer}>
						<Content padder keyboardShouldPersistTaps={'handled'}>
							<Form ref="itemform">
								{!labour && (
									<Field
										name="ref"
										labelWidth={100}
										labelType="inline"
										label="Ref"
										emptyText="(optional) eg. item code"
										onSelectCurrent={item => this.selectedRef(item)}
										component={renderTypeAhead}
										data={itemRefs}
										autoFocus
									/>
								)}
								<Field name="description" labelWidth={100} labelType="inline" label="Description" component={textInput} />
								<Field name="unit" labelType="inline" label={labour ? 'Hourly Rate' : servicesOnly ? net + 'Cost' : net + 'Unit Price'} component={moneyInput} style={{}} />
								{!labour && !servicesOnly && (
									<Field name="unitname" label="Unit" labelWidth={100} labelType="inline" placeholder="(optional) kg, boxes, etc." selectTextOnFocus component={textInput} textAlign="right" />
								)}
								{(!servicesOnly || !!labour) && <Field name="qty" label={labour ? 'Hours' : 'Qty'} component={numberInput} minus={!inv} upDowns />}
								{!servicesOnly && <Field name="total" label={net + 'Total'} component={moneyInput} disabled minus={!inv} />}
								{!!this.props.vatReg && (
									<Field name="vatrate" labelType="inline" label="VAT Rate" component={renderPicker} style={{ marginTop: 25 }} pickerStyle={{ width: 80, justifyContent: 'flex-end' }}>
										{vatRates.map((item, i) => (
											<Picker.Item key={i} label={Number(item.rate).toString() + '%'} value={Number(item.rate).toString()} />
										))}
									</Field>
								)}
								{inv &&
									(!showDiscount ? (
										<Button transparent style={{ alignSelf: 'flex-end' }} onPress={() => this.setState({ showDiscount: true })}>
											<Text note>Add Discount</Text>
										</Button>
									) : (
										<Field name="discount" label="Discount" component={moneyInput} />
									))}
							</Form>
						</Content>
						{!labour && (
							<Footer>
								<Button
									block
									transparent
									onPress={() => {
										changeServicesOnly(!servicesOnly);
										this.setState({ servicesOnly: !servicesOnly });
									}}>
									<MaterialCommunityIcons name="scale" style={{ fontSize: 24, color: '#EEE' }} />
									<Text>{servicesOnly ? 'Add quantity / weight' : 'Services Only'}</Text>
								</Button>
							</Footer>
						)}
					</View>
				</View>
			</Modal>
		);
	}
}

export default reduxForm({
	form: 'invoiceItemForm',
	validate: syncValidate,
	asyncValidate,
	asyncBlurFields: ['total', 'unit', 'qty', 'ref']
})(invoiceItemForm);
